<template lang="pug">
  .component-backoffice-reservation-planner.row.column
    .row
      .column
        label Driver
          SelectizeDriver(v-model="driver")
      .column
        label Start Date
          DatePicker(v-model="startDate")
      .column
        label Contract duration
          input(type="number", min="1", v-model="contractDuration")
    .row
      .column
        label Parking Lot
          SelectizeParkingLot(@optionSelected="setParkingLot", @optionRemoved="unsetParkingSlot")
      .column
        label Plan to be activated ({{ planId }})
          select(v-model="planId")
            option(:value="null") - NO PLAN -
            option(v-for="p in plans" :value="p.id") {{ p.name }}
    .row
      .column
        label Enable custom &nbsp;
          input(type="checkbox", v-model="multipleMode")
    .row
      .column(v-if="plans.length > 0")
        label Presets shifts
          div(v-if="shiftsPresets" v-for="(p, i) in shiftsPresets" :style="{'background-color': p.color}")
            input(v-if="multipleMode" type="checkbox" v-model="selectedPresets[i]")
            input(v-else="multipleMode" type="radio" v-model="selectedPreset" :value="i")
            span(style="font-family: monospace;") &nbsp; [{{ getPlanName(p.plan_id) }}] {{ p.shift }}
      .column(v-if="multipleMode")
        label Custom shifts
          textarea(v-model="customShifts", placeholder="#C2C2C2 MON|TUE|WED|THU|FRI|SAT|SUN 08:00 09:00" rows="5", style="font-family: monospace;")
    br
    .row(v-if="multipleMode")
      .column
        label Selected shifts
          div(v-for="(p) in shifts")
            ul(style="font-family: monospace;")
              li {{ p }}
    .row
      .column
        ActionButton(:action="search") Search
    .grouped.card(v-for="(slots, key) in slotsByLots" :style="gridStyle(slots)" )
      h1.text-center {{key}}
      vehicle(v-for="(vehicle, id) in slots", :key="id", :item="vehicle.vehicle", v-if="!vehicle.vehicle.disabled",  type="search-result")
        ActionButton(:action="bookVehicle", :value="vehicle.vehicle.plate", :disabled="driver === null") Book


</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import BaseList from './BaseList'
import DatePicker from '../../components/structure/DatePicker'
import ActionButton from '../../components/structure/ui/ActionButton'
import collect from 'collect.js'
import Vehicle from '../../components/backoffice/Vehicle'
import SelectizeDriver from '../../components/structure/ui/lists/selectize/SelectizeDriver'
import MaggieHelper from 'src/maggieHelper'
import SelectizeParkingLot from '../../components/structure/ui/lists/selectize/SelectizeParkingLot'
import SelectizePlan from "../../components/structure/ui/lists/selectize/SelectizePlan"
import {mapState} from "vuex"

export default {
  name: 'ReservationPlanner',
  components: {
    SelectizePlan,
    SelectizeParkingLot,
    SelectizeDriver,
    Vehicle,
    ActionButton,
    DatePicker,
    BaseList,
  },
  data: function () {
    return {
      component: require('src/components/backoffice/Reservation.vue'),
      driver: null,
      startDate: null,
      contractDuration: 3,
      parkingLotId: null,
      planId: null,
      selectedPresets: [],
      selectedPreset: null,
      customShifts: '',
      vehicles: [],
      plans: [],
      multipleMode: false,
    }
  },
  created() {
    KeplerBackofficeSdk.selects.plans(true, (data) => {
      this.plans = data
      this.loading = false
    })
  },
  methods: {
    setParkingLot(obj) {
      this.parkingLotId = obj.id
    },
    unsetParkingSlot() {
      this.parkingLotId = null
    },
    bookVehicle(plate) {
      if (this.driver === null) {
        return
      }

      return KeplerBackofficeSdk.reservations.bookPlanning(this.getBody(plate), (x) => {
        //this.body.week_planning = this.body.week_planning.join(',')
        MaggieHelper.notification('Cargo', 'In progress')
        console.log(x)
        this.$router.push({ name: 'cargo-operation', params: { id: x.cargo_id } })
      })
    },
    search() {
      return KeplerBackofficeSdk.reservations.planning(this.getBody(), (data) => {
        this.vehicles = data
      })
    },
    getBody(plate) {
      return {
        driver_id: this.driver ? this.driver.id : null,
        plate: plate,
        parking_lot_id: this.parkingLotId,
        plan_id: this.planId,
        week_planning: this.shifts,
        contract_duration: this.contractDuration,
        start_date: this.startDate,
      }
    },
    gridStyle(slots) {
      const auto = slots.length > 3 ? 'auto auto auto' : `repeat(${slots.length},auto)`
      return {
        gridTemplateColumns: auto
      }
    },
    getPlanName(id) {
      let v = null
      this.plans.forEach((p) => {
        if (p.id == id) {
          v = p.name
          return
        }
      })
      return v
    }
  },
  watch: {
    selectedPreset: function (n,o) {
      if (typeof this !== undefined) {
        this.planId = this.shiftsPresets[this.selectedPreset].plan_id
      }
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    shiftsPresets() {
      if (this.configuration) {
        return this.configuration.visual.visual_shifts.value
      } else {
        return []
      }
    },
    shifts() {
      let result = [];
      if (this.multipleMode) {
        let len = this.shiftsPresets.length
        let plan = null
        for (let i = 0; i < len; i++) {
          if (this.selectedPresets[i]) {
            if (!plan) {
              plan = this.shiftsPresets[i].plan_id
            }
            result.push(this.shiftsPresets[i].color + " " + this.shiftsPresets[i].shift)
          }
        }
        if (plan) {
          this.planId = plan
        }
        this.customShifts.split('\n').forEach((i) => {
          let trim = i.trim()
          if (trim.split(" ").length === 4) {
            result.push(trim)
          }
        })
      } else {
        if (this.shiftsPresets[this.selectedPreset]) {
          result.push(this.shiftsPresets[this.selectedPreset].color + " " + this.shiftsPresets[this.selectedPreset].shift)
        }
      }
      return result
    },
    slotsByLots() {
      const c = collect(this.vehicles)
      return c.groupBy((item) => {
        return item.vehicle.parking_lot.name
      }).all()

    }
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">
.component-backoffice-reservation-planner
  .activeIcon
    color: #64db6f

  .grouped
    display: grid
    grid-template-columns: auto auto auto
    @media(max-width: 600px)
      grid-template-columns: auto !important

    h1
      grid-column: 1/-1
</style>



// WEBPACK FOOTER //
// ReservationPlanner.vue?207b4094